<template>
    <div class="wrap-content customer-section">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-12 filter-title-section">
                    <h2>All Customers</h2>
                </div>
                <div class="col-md-12 filter-all-customers">
                    <div class="row">
                        <div class="col-md-4">
                            <b-form-group>
                                <b-form-radio-group
                                    v-model="query.status"
                                    :options="filterList"
                                    buttons
                                    button-variant="outline-primary"
                                    @change="setFilters"
                                ></b-form-radio-group>
                            </b-form-group>
                        </div>
                        <div class="col-md-3">
                            <div class="col-md-12">
                                <div class="col-xs-12">
                                    <a-range-picker
                                        :disabled-date="disabledDate"
                                        @change="onChange"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-md-4">
                                    <base-search
                                        placeholder="Search"
                                        @keyword="getKeyword"
                                    ></base-search>
                                </div>
                                <!-- :class="{
                                        'col-md-3': hasScopes(
                                            'export-customer-profile'
                                        ),
                                        'col-md-6': !hasScopes(
                                            'export-customer-profile'
                                        ),
                                    }" -->
                                <div class="col-md-3">
                                    <b-form-group>
                                        <button
                                            class="btn btn-primary"
                                            type="submit"
                                            :class="
                                                loading && showPageLoader
                                                    ? 'disabled'
                                                    : ''
                                            "
                                            @click="apply"
                                        >
                                            <span class="btn-text">Apply</span>
                                            <span class="loader"></span>
                                        </button>
                                    </b-form-group>
                                </div>
                                <!-- v-if="hasScopes('export-customer-profile')" -->
                                <div class="col-md-2">
                                    <b-form-group>
                                        <b-button
                                            type="button"
                                            variant="secondary"
                                            class="secondary-add-btn"
                                            @click="exportRecords"
                                        >
                                            <span class="btn-text">EXPORT</span>
                                        </b-button>
                                    </b-form-group>
                                </div>
                                <div
                                    class="col-md-3 text-right export-file-btn"
                                >
                                    <!-- Using modifiers -->
                                    <b-button
                                        v-b-toggle.collapse-2
                                        :style="{ backgroundColor: '#8b6f87' }"
                                        @click="onClickButtonDropdown"
                                    >
                                        Show Exports
                                    </b-button>

                                    <!-- Element to collapse -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <b-collapse id="collapse-2">
                        <b-table
                            v-if="data_downloads && data_downloads.length"
                            :items="data_downloads"
                            :fields="fields_downloads"
                        >
                            <template slot="updatedAt" slot-scope="data">
                                <span>{{
                                    data.item.updatedAt
                                        | moment('MMMM Do YYYY, h:mm:ss a')
                                }}</span>
                            </template>
                            <template slot="documentType">
                                <span>
                                    <excel-icon
                                        style="width: 24px"
                                    ></excel-icon>
                                </span>
                            </template>
                            <template slot="documentName" slot-scope="data">
                                <span>
                                    {{
                                        data.item.title ||
                                        'Export All Customers'
                                    }}
                                </span>
                            </template>
                            <template slot="fileName" slot-scope="data">
                                <b-link
                                    :href="`${APP_URL}files/export/${data.item.fileName}`"
                                    :disabled="
                                        data.item.status == 'completed'
                                            ? false
                                            : true
                                    "
                                    >{{
                                        data.item.status == 'completed'
                                            ? 'Download'
                                            : 'Document is in process'
                                    }}</b-link
                                >
                            </template>
                        </b-table>
                        <b-card v-else>
                            <h2>
                                There are no downloadable files ready for this
                                data segment, please request a file from the
                                export button
                            </h2>
                        </b-card>
                    </b-collapse>
                </div>
            </div>
        </div>

        <div
            :class="[
                'table-section',
                'table-min-width',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table
                :items="data"
                :fields="fields"
                no-local-sorting
                @sort-changed="sortingChanged"
            >
                <template slot="pictureURL" slot-scope="data">
                    <div class="profile-area">
                        <router-link
                            :to="{
                                name: 'customer-information',
                                params: {
                                    id: data.item._id,
                                },
                            }"
                        >
                            <div
                                v-if="data.item.pictureURL"
                                v-authenticated-image="data.item.pictureURL"
                                class="profile-pic"
                            ></div>
                        </router-link>
                    </div>
                </template>

                <template slot="idenfoId" slot-scope="data">
                    <div class="customer-link">
                        <span
                            v-if="data.item.status === 'processing'"
                            class="gray-text"
                        >
                            {{ data.item.idenfoId }}</span
                        >
                        <router-link
                            v-else
                            :to="{
                                name: 'customer-information',
                                params: {
                                    id: data.item._id,
                                },
                            }"
                        >
                            {{ data.item.idenfoId }}
                        </router-link>
                    </div>
                </template>

                <template slot="clientId" slot-scope="data">
                    <div class="customer-link">
                        <span
                            v-if="data.item.status === 'processing'"
                            class="gray-text"
                        >
                            {{ data.item.clientId }}</span
                        >
                        <router-link
                            v-else
                            :to="{
                                name: 'customer-information',
                                params: {
                                    id: data.item._id,
                                },
                            }"
                        >
                            {{
                                data.item.clientId ? data.item.clientId : 'N/A'
                            }}
                        </router-link>
                    </div>
                </template>

                <template slot="fullName" slot-scope="data">
                    <div class="action-flex">
                        <span
                            v-if="data.item.status === 'processing'"
                            class="gray-text"
                            >{{ data.item.fullName | titleCase }}</span
                        >
                        <router-link
                            v-else
                            :to="{
                                name: 'customer-information',
                                params: {
                                    id: data.item._id,
                                },
                            }"
                        >
                            <span>
                                {{ data.item.fullName | titleCase }}
                            </span>
                        </router-link>
                    </div>
                </template>

                <template slot="score" slot-scope="data">
                    <span
                        :class="
                            data.item.status == 'processing' ? 'gray-text' : ''
                        "
                        >{{ data.item.score ? data.item.score : '00' }}</span
                    >
                </template>

                <!-- Join Date -->
                <template slot="createdAt" slot-scope="data">
                    <span
                        :class="
                            data.item.status == 'processing' ? 'gray-text' : ''
                        "
                        >{{
                            data.item.createdAt | moment('MMM D, YYYY h:mm a')
                        }}</span
                    >
                </template>
                <template slot="updatedAt" slot-scope="data">
                    <span
                        :class="
                            data.item.status == 'processing' ? 'gray-text' : ''
                        "
                        >{{
                            data.item.updatedAt | moment('MMM D, YYYY h:mm a')
                        }}</span
                    >
                </template>

                <template slot="onboardedBy" slot-scope="data">
                    <span
                        :class="
                            data.item.status == 'processing' ? 'gray-text' : ''
                        "
                        >{{
                            data.item.onboardedBy
                                ? data.item.onboardedBy
                                : 'N/A'
                        }}</span
                    >
                </template>

                <template slot="status" slot-scope="data">
                    <base-status :status-type="data.item.status"></base-status>
                </template>

                <template slot="action" slot-scope="data">
                    <div class="action-review">
                        <base-action
                            icon="icon-eye-view"
                            label="View Profile"
                            :class="
                                data.item.status == 'processing'
                                    ? 'disable-color'
                                    : ''
                            "
                            @click="
                                data.item.status !== 'processing' &&
                                    $router.push({
                                        name: 'customer-information',
                                        params: { id: data.item._id },
                                    })
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>

        <base-records
            path="customers/"
            :query="query"
            :reset="reset"
            :show-pagination="true"
        ></base-records>

        <export-popup
            :id="id"
            title="Export Bulk Customer's Data"
            :url="cancelUrl"
            :query="query"
        ></export-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ExportPopup from '../../components/popups/ExportPopup.vue'
import request from '@/utils/request'
import excelIcon from '@/components/icons/ExcelIcon.vue'
import pdfIcon from '@/components/icons/PdfIcon.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        ExportPopup,
        excelIcon,
        pdfIcon,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        let sortByCustomer = localStorage.getItem('sortByCustomer')
            ? localStorage.getItem('sortByCustomer')
            : 'customerId'
        let sortOrderCustomer = localStorage.getItem('sortOrderCustomer')
            ? localStorage.getItem('sortOrderCustomer')
            : 'desc'
        let customerFilter =
            localStorage.getItem('customerFilter') != 'null'
                ? localStorage.getItem('customerFilter')
                : null
        return {
            APP_URL: process.env.VUE_APP_API_URL,
            data_downloads: [],
            toggle: false,
            dateType: '',
            fields_downloads: {
                updatedAt: {
                    label: 'Created At',
                    sortable: true,
                    tdAttr: {
                        dataname: 'updatedAt',
                    },
                },
                documentType: {
                    label: 'Document Type',
                    sortable: true,
                    tdAttr: {
                        dataname: 'documentType',
                    },
                },
                documentName: {
                    label: 'Document Name',
                    sortable: true,
                    tdAttr: {
                        dataname: 'documentName',
                    },
                },
                fileName: {
                    label: 'Download Link',
                    sortable: true,
                    tdAttr: {
                        dataname: 'fileName',
                    },
                },
            },
            fields: {
                pictureURL: {
                    label: '',
                    tdClass: 'profile-absolute',
                    tdAttr: {
                        dataname: '',
                    },
                },
                idenfoId: {
                    label: 'CUSTOMER',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Customer',
                    },
                },
                clientId: {
                    label: 'CLIENT ID',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Client ID',
                    },
                },
                fullName: {
                    label: 'FULL NAME',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Full Name',
                    },
                    tdClass: 'email-truncate',
                },
                nationality: {
                    key: 'basicInfo.nationality',
                    label: 'NATIONALITY',
                    sortable: true,
                    tdAttr: {
                        dataname: 'nationality',
                    },
                },
                countryOfResidence: {
                    key: 'basicInfo.countryOfResidence',
                    label: 'RESIDENCE',
                    sortable: true,
                    tdAttr: {
                        dataname: 'countryOfResidence',
                    },
                },
                score: {
                    label: 'SCORE',
                    sortable: true,
                    tdAttr: {
                        dataname: 'score',
                    },
                },
                createdAt: {
                    label: 'REGISTRATION DATE',
                    sortable: true,
                    tdAttr: {
                        dataname: 'createdAt',
                    },
                },
                updatedAt: {
                    label: 'LAST UPDATED',
                    sortable: true,
                    tdAttr: {
                        dataname: 'updatedAt',
                    },
                },
                onboardedBy: {
                    label: 'Onboarded By',
                    sortable: true,
                    tdAttr: {
                        dataname: 'onboardedBy',
                    },
                },
                status: {
                    label: 'STATUS',
                    sortable: true,
                    tdClass: 'text-center status-absolute-pos',
                    thClass: 'text-center',
                    tdAttr: {
                        dataname: 'status',
                    },
                },
                action: {
                    label: 'Actions',
                    tdClass: 'w-150px',
                    tdAttr: {
                        dataname: 'Actions',
                    },
                },
            },
            path: 'customers/',
            filterList: [
                { text: 'All', value: null },
                { text: 'Processing', value: 'processing' },
                { text: 'Pending', value: 'pending' },
                { text: 'Approved', value: 'approved' },
                { text: 'Rejected', value: 'rejected' },
            ],
            optionsForAlerts: [
                // { text: 'Updated On', value: 'updated' },
                { text: 'Filter by Date', value: null },
                { text: 'Created On', value: 'created' },
            ],
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                status: customerFilter,
                sortBy: sortByCustomer,
                startDate: '',
                endDate: '',
                sortOrder: sortOrderCustomer,
            },
            reset: new Date().getTime(),
            id: null,
            cancelUrl: 'customers/cancel-export',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'data',
            'showPageLoader',
            'loading',
            'dataSegmentId',
            'hasScopes',
        ]),
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        // console.log("all customer", this.$store.getters.getField('pagination'))
        localStorage.setItem('goBackUrl', this.$route.name)
        let queryData = JSON.parse(localStorage.getItem('queryData'))
        if (queryData) {
            Object.assign(this.query, queryData)
            localStorage.removeItem('queryData')
        }
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        disabledDate(current) {
            // Can not select days after today
            return current > this.$moment().endOf('day')
        },
        /**
         *
         * checking for available export file from customer export
         */
        async onClickButtonDropdown() {
            this.toggle = !this.toggle
            if (this.toggle) {
                console.log('Callin API')
                let { data } = await request.get(
                    `customers/getCustomerExportInfo/${this.dataSegmentId}`,
                    null
                )
                for (let i = 0; i < data.length; i++) {
                    const element = data[i]
                    if (
                        element.exportDocumentTypeId ==
                        '6266de303902cdae4c71337f'
                    ) {
                        data.splice(i, 1)
                    }
                }
                this.data_downloads = data
                console.log('data_downloads', data)
            }
        },
        /**
         *
         * @return {void}
         */
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method

        /**
         *
         * @return {void}
         */
        apply() {
            this.$store.commit('setLoading', true)
            this.reset = new Date().getTime()
        }, // End of apply() method

        /**
         *
         * @return {void}
         */
        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        /**
         *
         * @return {void}
         */
        async sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
            await localStorage.setItem('sortByCustomer', this.query.sortBy)
            await localStorage.setItem(
                'sortOrderCustomer',
                this.query.sortOrder
            )
            this.apply()
            this.$store.commit('setLoading', false)
        }, // End of sortingChanged() method
        async setFilters(flt) {
            await localStorage.setItem('customerFilter', flt)
            this.apply()
        },

        onChange(dateString) {
            this.query.startDate = dateString[0]
            this.query.endDate = dateString[1]
            console.log('QUERY', this.query)
        },
        /**
         *
         * @return {void}
         */
        async exportRecords() {
            try {
                // this.query.dataSegmentId = this.dataSegmentId
                // this.query.startDate = "2023-08-30"
                // this.query.endDate = "2023-08-30"
                // this.query.status="engine-approved"

                // let { data } = await request.post('customers/export', null, {
                //     params: this.query,
                // })

                // console.log('data  ' + JSON.stringify(data))

                // this.id = data.data.id
                this.$bvModal.show('export-popup')
                // this.$toasted.show(data.message, {
                //     type: 'success',
                // })
            } catch (error) {
                // console.log(error, 'error')
            }
        }, // End of exportRecords() method
    }, // End of Component > mounted
} // End of export default
</script>
